export const getStandardErrorPageConfig = ({ errorData, resourceName }) => {
    const statusCode = errorData?.statusCode;

    if (errorData?.displayMessage) {
        return {
            subtitle: errorData.displayMessage,
            showReloadButton: false,
            showBackButton: true,
        };
    }

    if (statusCode === 429) {
        return {
            subtitle: 'Too many requests. Please wait a moment and try again.',
            showReloadButton: true,
            showBackButton: false,
        };
    }

    if (statusCode === 404) {
        return {
            subtitle: `This ${resourceName} could not be found.`,
            showReloadButton: false,
            showBackButton: true,
        };
    }

    if (statusCode >= 500) {
        return {
            subtitle: 'Something went wrong.',
            showReloadButton: true,
            showBackButton: false,
        };
    }

    return {
        subtitle: `Unable to load ${resourceName}.`,
        showReloadButton: false,
        showBackButton: true,
    };
};
